import React from 'react';
import { CourseCertificateTag } from './styles';

export function CourseCertificateAwardTag() {
    return <CourseCertificateTag>
        <i className="bi bi-award"></i> Este curso oferece certificado!
    </CourseCertificateTag>;
}
